// extracted by mini-css-extract-plugin
export default {"gridWrapper":"ImageGrid_gridWrapper__H2xJE","image":"ImageGrid_image__KxEBA"};